import React from "react";
import { FaFacebookF, FaInstagram, FaTwitter, FaLinkedinIn } from "react-icons/fa";

function Footer() {
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  return (
<footer 
  className="bg-black footer-glow text-white py-12 sm:py-16 md:py-20"
  data-aos="fade-up"
>


      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8 md:gap-10 border-b border-gray-700 pb-8 sm:pb-10 md:pb-12">
          {/* Brand Section */}
          <div className="sm:col-span-2 lg:col-span-1">
            <h2 className="text-xl sm:text-2xl font-bold mb-3 sm:mb-4 bg-gradient-to-r from-white to-gray-300 bg-clip-text text-transparent">
              OʀɪsᴏɴSᴇʀᴠɪᴄᴇs
            </h2>
            <p className="text-gray-400 mb-3 sm:mb-4 text-sm sm:text-base">Follow us</p>
            <div className="flex space-x-3 sm:space-x-4 text-lg sm:text-xl mb-4 sm:mb-0">
              <a href="#" className="hover:text-blue-400 hover:scale-110 active:scale-95 transition-all duration-300 ease-in-out transform touch-manipulation"><FaFacebookF /></a>
              <a href="#" className="hover:text-pink-400 hover:scale-110 active:scale-95 transition-all duration-300 ease-in-out transform touch-manipulation"><FaInstagram /></a>
              <a href="#" className="hover:text-blue-300 hover:scale-110 active:scale-95 transition-all duration-300 ease-in-out transform touch-manipulation"><FaTwitter /></a>
              <a href="#" className="hover:text-blue-500 hover:scale-110 active:scale-95 transition-all duration-300 ease-in-out transform touch-manipulation"><FaLinkedinIn /></a>
            </div>
            <p className="text-gray-500 text-xs sm:text-sm mt-4 sm:mt-6">
              All rights reserved by © OʀɪsᴏɴSᴇʀᴠɪᴄᴇs
            </p>
          </div>

          {/* Column 1 */}
          <div className="text-gray-400 space-y-2 sm:space-y-3">
            <h3 className="font-semibold text-white mb-3 sm:mb-4 text-base sm:text-lg">Company</h3>
            <a href="#about" onClick={(e) => { e.preventDefault(); scrollToSection("about"); }} className="block hover:text-white active:text-gray-300 transition-colors duration-200 ease-in-out cursor-pointer text-sm sm:text-base touch-manipulation py-1">About us</a>
            <a href="#" className="block hover:text-white active:text-gray-300 transition-colors duration-200 ease-in-out text-sm sm:text-base touch-manipulation py-1">Social Media</a>
            <a href="#services" onClick={(e) => { e.preventDefault(); scrollToSection("services"); }} className="block hover:text-white active:text-gray-300 transition-colors duration-200 ease-in-out cursor-pointer text-sm sm:text-base touch-manipulation py-1">Services</a>
          </div>

          {/* Column 2 */}
          <div className="text-gray-400 space-y-2 sm:space-y-3">
            <h3 className="font-semibold text-white mb-3 sm:mb-4 text-base sm:text-lg">Support</h3>
            <a href="#" className="block hover:text-white active:text-gray-300 transition-colors duration-200 ease-in-out text-sm sm:text-base touch-manipulation py-1">Career</a>
            <a href="#contact" onClick={(e) => { e.preventDefault(); scrollToSection("contact"); }} className="block hover:text-white active:text-gray-300 transition-colors duration-200 ease-in-out cursor-pointer text-sm sm:text-base touch-manipulation py-1">Contact us</a>
            <a href="#" className="block hover:text-white active:text-gray-300 transition-colors duration-200 ease-in-out text-sm sm:text-base touch-manipulation py-1">Location</a>
          </div>

          {/* Column 3 */}
          <div className="text-gray-400 space-y-2 sm:space-y-3">
            <h3 className="font-semibold text-white mb-3 sm:mb-4 text-base sm:text-lg">More Info</h3>
            <a href="#" className="block hover:text-white active:text-gray-300 transition-colors duration-200 ease-in-out text-sm sm:text-base touch-manipulation py-1">Location</a>
            <a href="#" className="block hover:text-white active:text-gray-300 transition-colors duration-200 ease-in-out text-sm sm:text-base touch-manipulation py-1">Address</a>
            <a href="#" className="block hover:text-white active:text-gray-300 transition-colors duration-200 ease-in-out text-sm sm:text-base touch-manipulation py-1">Login</a>
          </div>
        </div>

        {/* Bottom Line */}
        <div className="flex flex-col sm:flex-row justify-between items-center mt-6 sm:mt-8 text-gray-400 text-xs sm:text-sm gap-3 sm:gap-0">
          <p className="text-center sm:text-left">© {new Date().getFullYear()} OrisonServices. All rights reserved.</p>
          <div className="flex items-center space-x-3 sm:space-x-4">
            <a href="#" className="hover:text-white active:text-gray-300 transition-colors duration-200 ease-in-out touch-manipulation">Privacy & Policy</a>
            <span className="text-gray-600">|</span>
            <a href="#" className="hover:text-white active:text-gray-300 transition-colors duration-200 ease-in-out touch-manipulation">Terms & Conditions</a>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
